import { axiosInstance } from '@configs/axios/axiosInstance';

import type {
  GetInstructorsFilterOptionsResult,
  InstructorsFilterOptions,
} from './getInstructorsFilterOptions.types';

import { normalizeFilterOptions } from './getInstructorsFilterOptions.utils';

/**
 * Fetch available filter options for instructors (disciplines, programs, locations).
 * Endpoint: GET /instructors/filters
 *
 * @param customerId - The ID of the customer, sent as a request header.
 * @returns An object containing arrays of filter options for disciplines, programs, and locations.
 * @throws Error if customerId is invalid or if the request fails.
 * @example
 * const filterOptions = await getInstructorsFilterOptions('customer-123');
 */
export async function getInstructorsFilterOptions(
  customerId: string
): Promise<InstructorsFilterOptions> {
  const { data } = await axiosInstance.get<GetInstructorsFilterOptionsResult>(
    '/instructors/filters',
    { headers: { 'X-Customer-Id': customerId } }
  );

  return normalizeFilterOptions(data);
}
